// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper___cR12","title":"styles_title__v1qZt","sliderWrap":"styles_sliderWrap__Zsh2y"};
module.exports.__checksum = "1692b1284605"